// extracted by mini-css-extract-plugin
module.exports = {"advantageWrapper":"advantage-card_advantageWrapper__zz260","advantageTitle":"advantage-card_advantageTitle__CR4Ui"};